import { api } from "./BackendService";

export const create = (data) => api.post("/brokers", data);
export const edit = (id, data) => api.put(`/brokers/${id}`, data);
export const getById = (id) => api.get(`/brokers/${id}`);

export const getAccreditation = (brokerId, accreditationId) =>
  api.get(`/brokers/${brokerId}/accreditations/${accreditationId}`);
export const updateAccreditation = (brokerId, accreditationId, data) =>
  api.put(`/brokers/${brokerId}/accreditations/${accreditationId}`, data);
export const removeAccreditation = (brokerId, accreditationId) =>
  api.delete(`/brokers/${brokerId}/accreditations/${accreditationId}`);

export const listAccreditationLogs = (brokerId) =>
  api.get(`/brokers/${brokerId}/accreditation-logs`);
export const getAccreditationLog = (brokerId, accreditationLogId) =>
  api.get(`/brokers/${brokerId}/accreditation-logs/${accreditationLogId}`);

export const list = (page, search, pageSize = 6) =>
  api.get("/brokers", { params: { page, search, pageSize } });
export const listLogs = (id, page) =>
  api.get(`/brokers/${id}/roulette-logs`, { params: { page: page } });
